var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { Entity, Type } from '@decahedron/entity';
import { Option } from './Option';
import { Tags } from './Tags';
import { Answer } from 'packages/form/entities/legacy/question/Answer';
import { v4 as uuid } from 'uuid';
import moment from 'moment';
var Question = /** @class */ (function (_super) {
    __extends(Question, _super);
    function Question() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'text';
        _this.subtype = '';
        _this.label = '';
        _this.companyId = null;
        _this.slug = null;
        _this.publishedAt = null;
        _this.attribute = null;
        _this.position = 0;
        _this.score = null;
        _this.createdAt = '';
        _this.uuid = null;
        _this.answer = [];
        _this.validationRule = [];
        _this.tags = null;
        _this.options = null;
        return _this;
    }
    Question.prototype.hasTag = function (tag) {
        if (!this.tags || (!this.tags.system && !this.tags.user)) {
            return false;
        }
        return (this.tags.system && this.tags.system.includes(tag))
            || (this.tags.user && this.tags.user.includes(tag));
    };
    Object.defineProperty(Question.prototype, "isAllowedToMakeOptional", {
        get: function () {
            if (this.type === 'text'
                && this.tags
                && this.tags.system
                && this.tags.system.includes(Tags.CONTACT)
                && (this.subtype === 'email'
                    || this.subtype === 'name')) {
                return false;
            }
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Question.prototype, "validationRulesForSubmission", {
        get: function () {
            if (this.type === 'file') {
                return this.validationRule.filter(function (rule) { return rule !== 'file'; });
            }
            if (this.subtype === 'website') {
                return __spreadArray(__spreadArray([], this.validationRule), ['url']);
            }
            return this.validationRule;
        },
        enumerable: false,
        configurable: true
    });
    Question.prototype.resetUuid = function () {
        this.uuid = uuid();
    };
    Question.prototype.hasValidationRule = function (rule) {
        return typeof this.validationRule.find(function (word) { return word === rule; }) !== 'undefined';
    };
    Question.prototype.addValidationRule = function (rule) {
        if (!this.hasValidationRule(rule)) {
            this.validationRule.push(rule);
        }
    };
    Question.prototype.removeValidationRule = function (rule) {
        this.validationRule = this.validationRule.filter(function (word) { return word !== rule; });
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Question.prototype.fromJson = function (jsonData) {
        var _this = this;
        var _a;
        _super.prototype.fromJson.call(this, jsonData);
        /* Remove duplicates */
        if ((_a = this.answer) === null || _a === void 0 ? void 0 : _a.length) {
            this.answer = Array.from(new Set(this.answer.map(function (a) { return a.uuid; })))
                .map(function (uuid) { return _this.answer.find(function (a) { return a.uuid === uuid; }); });
        }
        return this;
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Question.prototype.toJson = function (toSnake, asString) {
        var result = _super.prototype.toJson.call(this, toSnake, asString);
        if (result.createdAt) {
            result.created_at = moment(result.createdAt).format();
        }
        return result;
    };
    var _a;
    __decorate([
        Type(Answer),
        __metadata("design:type", Array)
    ], Question.prototype, "answer", void 0);
    __decorate([
        Type(Tags),
        __metadata("design:type", typeof (_a = typeof Tags !== "undefined" && Tags) === "function" ? _a : Object)
    ], Question.prototype, "tags", void 0);
    __decorate([
        Type(Option),
        __metadata("design:type", Array)
    ], Question.prototype, "options", void 0);
    return Question;
}(Entity));
export { Question };
